<h1 mat-dialog-title>{{ 'CASES.single.rebuild-plan' | translate }}</h1>
<div mat-dialog-content>
  <form [formGroup]="form">
    <div class="form-group" style="margin-bottom: 0">
      <mat-form-field appearance="fill">
        <mat-label>Choose an option</mat-label>
        <mat-select formControlName="rebuild_type">
          <mat-option value="full_from_start">{{ 'CASES.single.rebuild-payment-option-1' | translate }}</mat-option>
          <mat-option value="full_preserve_dates">
            Rebuild from beginning (Preserve dates)
          </mat-option>
          <mat-option value="only_unpaid_v2">
            {{ 'CASES.single.rebuild-payment-option-2' | translate }}
          </mat-option>
          <mat-option value="reapply_funds">
            {{ 'CASES.single.rebuild-payment-option-reapply_funds' | translate }}
          </mat-option>
          <mat-option value="manual_from_beginning">
            {{ 'CASES.single.rebuild-payment-option-3' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-error *ngIf="form.get('rebuild_type').touched && form.get('rebuild_type').errors?.required">
        {{ "SHARED.field-required" | translate }}
      </mat-error>
    </div>
    <p
      *ngIf="form.get('rebuild_type').value === 'full_from_start'">{{ 'CASES.single.rebuild-payment-option-1-note' | translate }}</p>
    <p
      *ngIf="form.get('rebuild_type').value === 'only_unpaid_v2'">{{ 'CASES.single.rebuild-payment-option-2-note' | translate }}</p>
    <div *ngIf="form.get('rebuild_type').value === 'manual_from_beginning'" class="row">
      <!--Phase 1 -->
      <div class="col-6 mb-2">
        <h5><b>{{'PAYMENTS.phase_one' | translate}}</b></h5>
        <p>
          {{'CASES.single.rebuild-payment-option-3-note-phase-1' | translate}}
          <b>{{phaseOneAmountLeft}}€</b>
        </p>
        <div *ngFor="let formGroup of getFormArray('phase_one_installments').controls let i = index" formArrayName="phase_one_installments" [@inOutAnimation]>
          <div class="d-flex align-items-center pb-3">
            <span class="pe-2">{{i + 1}}.</span>
            <div class="" [formGroupName]="i">
              <input type="number" class="form-control" formControlName="amount">
            </div>
            <button mat-icon-button color="warn" class="ms-2" (click)="removeInstallment('phase_one_installments', i, $event)">
              <mat-icon class="text-danger mat-icon" aria-hidden="false" aria-label="Example home icon">remove_circle
              </mat-icon>
            </button>
          </div>
        </div>
        <mat-error *ngIf="phaseOneAmountLeft < 0">
          {{'CASES.single.rebuild-payment-option-3-minus-error' | translate}}
        </mat-error>
        <button *ngIf="phaseOneAmountLeft > 0" mat-raised-button color="primary" (click)="addInstallment('1', $event)">
          + {{ 'CASES.single.rebuild-payment-add-installment-1' | translate }}
        </button>
      </div>
      <!--Phase 2 -->
      <div class="col-6 mb-2">
        <h5><b>{{'PAYMENTS.phase_two' | translate}}</b></h5>
        <p>
          {{'CASES.single.rebuild-payment-option-3-note-phase-2' | translate}}
          <b>{{phaseTwoAmountLeft}}€</b>
        </p>
        <div *ngFor="let formGroup of getFormArray('phase_two_installments').controls let i = index" formArrayName="phase_two_installments" [@inOutAnimation]>
          <div class="d-flex align-items-center pb-3">
            <span class="pe-2">{{i + 1}}.</span>
            <div class="" [formGroupName]="i">
              <input type="number" class="form-control" formControlName="amount">
            </div>
            <button mat-icon-button color="warn" class="ms-2" (click)="removeInstallment('phase_two_installments', i, $event)">
              <mat-icon class="text-danger mat-icon" aria-hidden="false" aria-label="Example home icon">remove_circle
              </mat-icon>
            </button>
          </div>
        </div>
        <mat-error *ngIf="phaseTwoAmountLeft < 0">
          {{'CASES.single.rebuild-payment-option-3-minus-error' | translate}}
        </mat-error>
        <button *ngIf="phaseTwoAmountLeft > 0" mat-raised-button color="primary" (click)="addInstallment('2', $event)">
          + {{ 'CASES.single.rebuild-payment-add-installment-2' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions class="py-4 justify-content-end">
  <button mat-button class="mr-3" (click)="cancelRebuild()">{{ "SHARED.cancel" | translate }}</button>
  <app-spinner-btn [loading]="isSubmitting" [name]="'SHARED.save' | translate" (click)="submitForm(form)">
  </app-spinner-btn>
</div>
